export default {
  name: 'misc.occupation',
  key: 'occupation',
  attributes: {
    researchers: {
      key: 'researchers',
      name: 'entity.moonBase.occupation.researchers',
    },
    genius: {
      key: 'genius',
      name: 'entity.moonBase.occupation.genius',
    },
    colony: {
      key: 'colony',
      name: 'entity.moonBase.occupation.colony',
    },
    military: {
      key: 'military',
      name: 'entity.moonBase.occupation.military',
    },
    miners: {
      key: 'miners',
      name: 'entity.moonBase.occupation.miners',
    },
  },
};
